import Rebate from './rebate';
export default Rebate;
